<nav data-scroll-lock-scrollable :class="`nav--${nav.length}`"><NavigationItem v-for="(item, i) in nav" :item="item" :index="i"></NavigationItem></nav>